export const getPostAuthRedirectPath = (user) => {
  if (!user) return '/auth/sign-in';

  if (!user.isEmailVerified) {
    return '/email-verification';
  }

  if (user.role === 'partner' && user.validationStatus !== 'approved') {
    return '/verification/pending';
  }

  if (user.role === 'admin') {
    return '/admin/dashboard';
  }

  if (user.role === 'partner') {
    return '/dashboard/partner';
  }

  return '/dashboard/client';
};
